import { addCollection } from '@iconify/vue2';
import iconSet from 'assets/icons.json';

export default function () {
  addCollection(iconSet, 'custom');
}
